import { IconButton, Stack, SvgIcon } from "@mui/joy";
import { motion } from "framer-motion";
import { createSvgIcon } from "@mui/material";
import { memo } from "react";

function PatientMenuBar({
  highlight,
  disabled,
  onClick,
}: {
  highlight?: boolean;
  disabled: boolean;
  onClick: () => void;
}) {
  const NextIcon = createSvgIcon(
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M7.43301 11C7.24056 11.3333 6.75944 11.3333 6.56699 11L2.23686 3.5C2.04441 3.16667 2.28497 2.75 2.66987 2.75L11.3301 2.75C11.715 2.75 11.9556 3.16667 11.7631 3.5L7.43301 11Z" />
    </svg>,
    "Next"
  );

  return (
    <Stack direction={"row"} justifyContent="end" sx={{ pt: "4px" }}>
      <motion.div
        style={{
          cursor: "pointer",
        }}
        animate={{
          opacity: highlight && !disabled ? [1, 0, 1] : 1,
        }}
        transition={{
          delay: 1,
          duration: highlight && !disabled ? 1 : 0,
          repeat: highlight && !disabled ? Infinity : 0,
        }}
      >
        <IconButton disabled={disabled} onClick={onClick}>
          <SvgIcon
            sx={{ width: "14px", height: "14px" }}
            color={disabled ? "soft" : "primary"}
            inheritViewBox
          >
            <NextIcon />
          </SvgIcon>
        </IconButton>
      </motion.div>
    </Stack>
  );
}

export default memo(PatientMenuBar);
